import { identity } from '@kofno/piper';
import { Decoder, field, number, oneOf, succeed } from 'jsonous';
import { readonlyArray } from '../../../../../Decoders';
import { resourceDecoder } from '../../../../../Resource/Decoders';
import {
  licenseAllocationsFormResourceDecoder,
  licenseResourceDecoder,
} from '../../../Participants/Table/LicenseAllocations/Decoders';
import {
  GroupBulkLicenseSubmittedPayload,
  GroupBulkLicenseSubmittedResource,
  ReadyResource,
  SubmissionResponse,
  SubmissionSuccess,
  ValidationErrors,
} from './Types';

// Groups-specific decoder for bulk license allocation (simple allocation only)
export const groupBulkLicenseSubmittedPayloadDecoder: Decoder<GroupBulkLicenseSubmittedPayload> =
  succeed({})
    .assign('allocatedLicenses', field('allocated_licenses', readonlyArray(licenseResourceDecoder)))
    .assign('userIds', field('user_ids', readonlyArray(number)));

export const groupBulkLicenseSubmittedResourceDecoder: Decoder<GroupBulkLicenseSubmittedResource> =
  resourceDecoder(groupBulkLicenseSubmittedPayloadDecoder);

export const submissionSuccessDecoder: Decoder<SubmissionSuccess> =
  groupBulkLicenseSubmittedResourceDecoder.map((resource) => ({
    kind: 'submission-success',
    resource,
  }));

export const validationErrorsDecoder: Decoder<ValidationErrors> =
  licenseAllocationsFormResourceDecoder.map((resource: ReadyResource) => ({
    kind: 'validation-errors',
    resource,
  }));

export const submissionResponseDecoder: Decoder<SubmissionResponse> = oneOf<SubmissionResponse>([
  submissionSuccessDecoder.map<SubmissionResponse>(identity),
  validationErrorsDecoder.map<SubmissionResponse>(identity),
]);
